module.exports = __webpack_public_path__ + "img/close_white.802622c0.svg";